var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewDocumentError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-585 -161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#f8f8f8",
    transform: "translate(585 161)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M660.001 206.001h-10a4 4 0 01-4-4v-9l14 13z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.999 239.5h-26.998a5.506 5.506 0 01-5.501-5.5v-36c0-3.033 2.467-5.5 5.501-5.5H646v8a5.506 5.506 0 005.499 5.501h8v28c0 3.032-2.467 5.5-5.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M653.999 239c2.757 0 5-2.242 5-5v-27.499h-7.5a6.006 6.006 0 01-5.999-6v-7.5h-18.499A5.005 5.005 0 00622 198v36c0 2.758 2.243 5 5.001 5h26.998m0 1h-26.998a6.006 6.006 0 01-6.001-6v-36c0-3.308 2.692-6 6.001-6h19.21l.289.29v8.21a5.005 5.005 0 004.999 5.001h8.211l.289.289V234c0 3.31-2.691 6-6 6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M645.503 192.708l.707-.707L660 205.79l-.708.706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M640.5 218.4a4.763 4.763 0 014.8 4.6 6.753 6.753 0 01-.2 1.4l2.9 2.8a10.484 10.484 0 003-4.2 11.371 11.371 0 00-10.5-6.9 13.449 13.449 0 00-3.5.5l2.1 2a5.9 5.9 0 011.4-.2zm-8.9-3.1a.854.854 0 000 1.3l1.9 1.8a11.324 11.324 0 00-3.5 4.6 11.3 11.3 0 0010.5 7 11.09 11.09 0 004.1-.8l2.6 2.5a.92.92 0 101.3-1.3L633 215.3a.967.967 0 00-1.4 0zm8.9 12.4a4.763 4.763 0 01-4.8-4.6 4.552 4.552 0 01.5-2l1.5 1.4c0 .2-.1.3-.1.5a2.883 2.883 0 002.9 2.8.749.749 0 00.5-.1l1.5 1.5a4.552 4.552 0 01-2 .5zm2.8-5a2.678 2.678 0 00-2.5-2.4z"
  }))));
}
export default SvgPreviewDocumentError;